import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';
// import * as constants from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getBanner() {
    try {
        const response = await serviceContext.get(ReportsURL + "banner", null, options);
        const res = response.json();
        return res;
    }
    catch (error) {
        return error;
    }
};

export async function uploadBanner(data) {
    try {
        const response = await serviceContext.post(ReportsURL + "banner", JSON.stringify(data), options);
        const res = response.json();
        return res;
    }
    catch (error) {
        return error;
    }
};

export async function removeBanner(data) {
    try {
        const response = await serviceContext.post(ReportsURL + "banner/remove", JSON.stringify(data), options);
        const res = response.json();
        return res;
    }
    catch (error) {
        return error;
    }
};